import { v4 } from "uuid";
// An id that is constant for the lifetime of the browser tab
export const browserSessionId = v4();
